export type PillarIconKey = 'speed' | 'cost' | 'network'

export type ManifestoPillar = {
  /** Selects the matching SVG illustration in PillarIcons.tsx. */
  iconKey: PillarIconKey
  /** Mirrors the gradient-accented word in the headline so each card visually
   *  anchors back to that promise. Omit to hide the accent row entirely. */
  accent?: { en: string; fa: string }
  num: string
  numFA: string
  en: string
  fa: string
  descEN: string
  descFA: string
}

export const pillars: ManifestoPillar[] = [
  {
    iconKey: 'speed',
    num: 'Streamlined and Rapid Campaign Management',
    numFA: 'مدیریت سریع و ساختاریافته‌ی کمپین‌ها',
    en: 'Streamlined and Rapid Campaign Management',
    fa: 'مدیریت سریع و ساختاریافته‌ی کمپین‌ها',
    descEN:
      'From initial brief to final performance report, we leverage agile processes to execute every stage in the shortest possible time.',
    descFA:
      'از تدوین بریف تا تحلیل و گزارش نهایی، ما با استفاده از فرآیندهای چابک، سرعت و دقت اجرای کمپین‌های شما را تضمین می‌کنیم.',
  },
  {
    iconKey: 'cost',
    num: 'Transparent Reporting',
    numFA: 'شفافیت کامل در ارائه نتایج',
    en: 'Transparent Reporting',
    fa: 'شفافیت کامل در ارائه نتایج',
    descEN:
      'Complete transparency at every stage; from budget allocation to final results, you have full oversight of your campaign performance',
    descFA: 'شفافیت کامل در تمامی مراحل؛ از بودجه‌بندی تا خروجی نهایی، همه چیز تحت نظارت شماست.',
  },
  {
    iconKey: 'network',
    num: 'Smart Decisions, Better Results',
    numFA: 'تصمیم‌های هوشمند، نتایج بهتر',
    en: 'Smart Decisions, Better Results',
    fa: 'تصمیم‌های هوشمند، نتایج بهتر',
    descEN: 'Run more effective campaigns with performance-driven insights',
    descFA: 'با تحلیل عملکرد، کمپین‌های اثربخش‌تری اجرا کنید.',
  },
]
